import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('commentsQueryString',
  pagingMaker({
    fetchType: actions.COMMENTS_FETCH,
    fetchSuccessType: actions.COMMENTS_FETCH_SUCCESS,
    fetchErrorType: actions.COMMENTS_FETCH_ERROR,
    possiblePageUpdateType: actions.COMMENTS_UPDATE_POSSIBLE_PAGE
  })
);



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/paging/byQuery/reducer.js
 **/